import { render, staticRenderFns } from "./TableCoupon.vue?vue&type=template&id=2ebc1e16&"
import script from "./TableCoupon.vue?vue&type=script&lang=js&"
export * from "./TableCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports